import { GraduationCap, BookOpen, Award } from 'lucide-react';

/**
 * Training type configurations for ISO/IATF standards
 * These are the 3 levels of training offered for each standard
 */
export const trainingTypes = {
  awareness: {
    id: 'awareness',
    title: 'Awareness Training',
    duration: '1 Day',
    level: 'All Employees',
    icon: GraduationCap,
    color: 'text-emerald-600',
    bgColor: 'bg-emerald-50',
    hoverColor: 'hover:bg-emerald-100',
    description: 'Introduction to the standard for all employees',
    detailedDescription: 'A foundational course designed to provide a comprehensive understanding of the standard and its requirements. Ideal for all employees who need to understand how the standard applies to their daily work.',
    price: 'Contact for pricing',
    targetAudience: [
      'All employees across the organization',
      'Management and supervisory staff',
      'Quality and compliance teams',
      'New hires and orientation programs'
    ]
  },
  'internal-auditor': {
    id: 'internal-auditor',
    title: 'Internal Auditor Training',
    duration: '3 Days',
    level: 'Auditors & QA Personnel',
    icon: BookOpen,
    color: 'text-blue-600',
    bgColor: 'bg-blue-50',
    hoverColor: 'hover:bg-blue-100',
    description: 'Comprehensive training to conduct internal audits',
    detailedDescription: 'An intensive course that equips participants with the knowledge and skills to plan, conduct, report, and follow up on internal audits. Includes practical exercises and case studies.',
    price: 'Contact for pricing',
    targetAudience: [
      'Internal auditors and audit team members',
      'Quality assurance personnel',
      'Process owners and managers',
      'Compliance officers'
    ]
  },
  'lead-auditor': {
    id: 'lead-auditor',
    title: 'Lead Auditor Training',
    duration: '5 Days',
    level: 'Senior Auditors & Consultants',
    icon: Award,
    color: 'text-purple-600',
    bgColor: 'bg-purple-50',
    hoverColor: 'hover:bg-purple-100',
    description: 'Advanced certification for leading audit teams',
    detailedDescription: 'The most comprehensive course designed for those who will lead audit teams. Covers advanced audit techniques, team management, and certification requirements. Includes assessment and certification.',
    price: 'Contact for pricing',
    targetAudience: [
      'Senior auditors and audit team leaders',
      'Management systems consultants',
      'Quality managers and directors',
      'Those seeking professional certification'
    ]
  }
};

/**
 * Get all training types as an array
 */
export const getAllTrainingTypes = () => Object.values(trainingTypes);

/**
 * Get a specific training type by ID
 */
export const getTrainingTypeById = (id) => trainingTypes[id];

/**
 * Get training types in order (awareness -> internal -> lead)
 */
export const getOrderedTrainingTypes = () => [
  trainingTypes.awareness,
  trainingTypes['internal-auditor'],
  trainingTypes['lead-auditor']
];
